// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"23b336a7","536":"32f662c6","787":"9749f68a","959":"eaa2c46f","961":"4aa9e87d"}[chunkId] + ".chunk.js";
};